module.exports = __webpack_public_path__ + "media/images/forgot-background-ca54ea508d972d0c4266d38056346d4c828ea21f0360fd3730c67cb636355d42.jpg";